import * as styles from './GradientLoader.module.css';
import React from 'react';

const GradientLoader = (props) => {
    return (
        <div style={{width:props.width,height:props.height}} ><div className={styles.GradientLoader} ></div></div>
    )
}

export default GradientLoader;